import React from 'react';
import AppContainer from '../app-container';
import * as postActions from '../../actions/post';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import InternalImageV2 from '../../components/internal-image-v2';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import HtmlRenderer from '../../components/html-renderer';

class StageRegistrationPageContainer extends AppContainer {

    componentWillMount() {
        this.props.actions.fetchPostBySlug(this.props.params.slug).then(this.handlePageResult.bind(this));
    }
    renderBody(post) {
        return (
            <div className="container">
                <h1 className="title">
                    <span>{post.title}
                    </span>
                </h1>
                <div className="post-body-container">
                    {post.image && <InternalImageV2 filename={post.image.filename} alt={post.title}/>}
                    <div className="post-body">
                        <HtmlRenderer html={post.body}/>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const {post} = this.props;
        const postTitle = post.item
            ? post.item.title
            : '';
        return (
            <DocumentTitle title={this.getDocumentTitle(postTitle)}>

                <div className="page-section">
                    {post.loading
                        ? <Loading/>
                        : this.renderBody(post.item)}
                </div>
            </DocumentTitle>
        )

    }
}
export default connect(function(state) {
    return {post: state.post.post};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...postActions
        }, dispatch)
    };
})(StageRegistrationPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/post-page-container.js